<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PdlxDN/tc-custom/9781480465404.jpg?1733113336281" alt="This image is the cover for the book Dangerous Series, Dangerous"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dangerous Series, Dangerous
      </h1>
      <p class="bookDescription body article font2">
        <b>Soldiers, strangers, and spies—love is a dangerous game in this collection of four Regency romances by a <i>USA Today</i>–bestselling author!</b><br/>  In <i>Dangerous Illusions</i>, Lady Daintry Tarrant is dismayed when a war hero returns, introducing himself as her fiancé, Lord Penthorpe. She cherishes her independence and has turned away many suitors, but this one she must marry. Penthorpe is completely captivated by Lady Daintry—but he’s not who he claims to be.<br/> In <i>Dangerous Games</i>, Melissa Seacourt’s father auctions her off to pay his gambling debts, but she vows that she will be no man’s bought bride. Desperate to escape her fate shackled to someone she could never love, Melissa instead is forced to honor and obey the seductive stranger who comes to her rescue.<br/><br/> In <i>Dangerous Angels</i>, Charlotte Tarrant is traveling across Cornwall in her luxurious coach when a shots ring out and her carriage goes over a cliff’s edge. As she clings to the rocks, a savior appears. When they meet again, Charley recognizes him instantly. But she doesn’t yet realize that the stranger who saved her life—the handsome aristocrat who now vies for her hand in marriage—is England’s most notorious spy.<br/><br/> In <i>Dangerous Lady</i>, Lady Letitia Deverill comes to London to serve as maid of honor to the young Queen Victoria. An impassioned Tory in a sea of Whigs, Letty has no intention of changing her political views. The headstrong noblewoman soon discovers she has enemies at court, and none more formidable than the powerful—and irresistible—Viscount Justin Raventhorpe.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amanda Scott
      </h2>
      
      <p class="authorDescription body article">&amp;lt;DIV&amp;gt;&amp;lt;B&amp;gt;Amanda Scott&amp;lt;/B&amp;gt; is the author of over 62 romance novels and the recipient of the Romance Writers of America's prestigious RITA Award. She lives in Folsom, California, outside of Sacramento. She is a fourth-generation Californian.&amp;lt;/DIV&amp;gt;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?04e202d4